import { StreamChannel } from '../services/channelsService';
import { useRuntimeChannel, useRuntimeOutput, useRuntimeStats } from '../contexts/RuntimeStatusContext';

export const useChannelState = (channel: StreamChannel | null) => {
  const { activeChannel } = useRuntimeChannel();
  const runtimeStats = useRuntimeStats();
  const runtimeOutput = useRuntimeOutput();
  const isActive = !!channel && activeChannel?.id === channel.id;

  return {
    stats: isActive ? runtimeStats.stats : null,
    analytics: isActive ? runtimeStats.analytics : null,
    transcoders: isActive ? runtimeOutput.transcoders : [],
    isStreamLive: isActive ? runtimeStats.isStreamLive : false,
  };
};
